module.exports = __webpack_public_path__ + "static/media/brand2.422440e6.png";